import React, { useEffect, useState } from 'react';

import { CreditCard, PriceChangeOutlined, VolunteerActivism } from '@mui/icons-material';
import { Alert, AlertTitle, Box } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CurrencyCard from '../components/utils/currencyCard.tsx';
import NoData from '../css/No-data-amico.svg';
import getReq from '../interface/getRequestinterface';
import postReq from '../interface/postRequestinterface';
import { getRequest, postRequest } from '../request';
import Loading from './loading';

const listOfColors = {
  gold: '#ffd700',
  goldbtn: '#d3bd48',
  silver: '#C0C0C0',
  silverbtn: '#7f7f7f',
  bronze: '#CD7F32',
  bronzebtn: '#886644',
  disabledBronze: '#cd7f32',
  disabledSilver: '#c0c0c0',
  disabledGold: '#ffd700'
}

const style = {
  formTitle: {
    fontWeight: 'bold !important'
  },
  formDescription: {
    color: '#9b9b9b'
  },
  formContainer: {
    padding: '1rem !important',
    border: '3px solid #748DA6',
    borderRadius: '10px',
    backgroundColor: '#f1f7ff59',
    height: 'auto'
  },
  gridBox: {
    display: 'grid',
    gridTemplateColumns: '30rem 30rem 30rem',
    columnGap: '2%',
    justifyContent: 'space-around',
    marginTop: '2rem'
  },
  mobileGridBox: {
    display: 'grid',
    gridTemplateColumns: 'auto',
    // columnGap:'5%',
    // rowGap:'7%',
    justifyContent: 'center',
    marginTop: '2rem'
  },
  tabletGridBox: {
    display: 'grid',
    gridTemplateColumns: '25rem 25rem',
    columnGap: '5%',
    justifyContent: 'center',
    marginTop: '2rem'
  },
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 4,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '3px',
    width: '30rem'
  },
  modalMobileStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 4,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '3px',
    width: '15rem'
  },
  txtField: {
    width: '100%',
  },
  headerContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between'
  },
  stateHandler: {
    display: 'flex',
    justifyContent: 'center'
  },
  stateType: { fontWeight: 'bold' },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '65rem',
  },
  defineServices: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    width: '30rem',
    height: '80vh'
  },
  goldServiceBoxMobile: {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: listOfColors.gold + 'a3',
    border: `3px solid ${listOfColors.gold}`,
    borderRadius: '0.3rem',
    textAlign: 'center'
  },
  silverServiceBoxMobile: {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: listOfColors.silver + 'a3',
    border: `3px solid ${listOfColors.silver}`,
    borderRadius: '0.3rem',
    textAlign: 'center'
  },
  bronzeServiceBoxMobile: {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: listOfColors.bronze + 'a3',
    border: `3px solid ${listOfColors.bronze}`,
    borderRadius: '0.3rem',
    textAlign: 'center'
  },
  goldServiceBox: {
    width: '23rem',
    padding: '0.5rem',
    backgroundColor: listOfColors.gold + 'a3',
    border: `3px solid ${listOfColors.gold}`,
    borderRadius: '0.3rem',
  },
  silverServiceBox: {
    width: '23rem',
    padding: '0.5rem',
    backgroundColor: listOfColors.silver + 'a3',
    border: `3px solid ${listOfColors.silver}`,
    borderRadius: '0.3rem',
  },
  bronzeServiceBox: {
    width: '23rem',
    padding: '0.5rem',
    backgroundColor: listOfColors.bronze + 'a3',
    border: `3px solid ${listOfColors.bronze}`,
    borderRadius: '0.3rem',

  },
  disabledGoldServiceBox: {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: listOfColors.disabledGold + '70',
    border: `3px solid ${listOfColors.disabledGold}` + '4a',
    borderRadius: '0.3rem',
    color: '#6a6a6a'
  },
  disabledSilverServiceBox: {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: listOfColors.disabledSilver + '70',
    border: `3px solid ${listOfColors.disabledSilver}` + '4a',
    borderRadius: '0.3rem',
    color: '#6a6a6a'
  },
  disabledBronzeServiceBox: {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: listOfColors.disabledBronze + '70',
    border: `3px solid ${listOfColors.disabledBronze}` + '4a',
    borderRadius: '0.3rem',
    color: '#6a6a6a'
  },
  disabledGoldServiceBoxMobile: {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: listOfColors.disabledGold + '70',
    border: `3px solid ${listOfColors.disabledGold}` + '4a',
    borderRadius: '0.3rem',
    color: '#6a6a6a',
    textAlign: 'center'
  },
  disabledSilverServiceBoxMobile: {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: listOfColors.disabledSilver + '70',
    border: `3px solid ${listOfColors.disabledSilver}` + '4a',
    borderRadius: '0.3rem',
    color: '#6a6a6a',
    textAlign: 'center'
  },
  disabledBronzeServiceBoxMobile: {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: listOfColors.disabledBronze + '70',
    border: `3px solid ${listOfColors.disabledBronze}` + '4a',
    borderRadius: '0.3rem',
    color: '#6a6a6a',
    textAlign: 'center'
  },
  goldServiceBtn: {
    backgroundColor: listOfColors.goldbtn,

  },
  silverServiceBtn: {
    backgroundColor: listOfColors.silverbtn,
  },
  bronzeServiceBtn: {
    backgroundColor: listOfColors.bronzebtn,
  },
  circleGold: {
    backgroundColor: '#ffe55c',
    borderRadius: '50%',
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-1.5rem',
    marginLeft: '-1rem',
    border: `3px solid ${listOfColors.gold}`
  },
  circleSilver: {
    backgroundColor: '#d7d7d7',
    borderRadius: '50%',
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-1.5rem',
    marginLeft: '-1rem',
    border: `3px solid ${listOfColors.silver}`
  },
  circleBronze: {
    backgroundColor: '#dfad7c',
    borderRadius: '50%',
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-1.5rem',
    marginLeft: '-1rem',
    border: `3px solid ${listOfColors.bronze}`
  },
  circleDisabledGold: {
    backgroundColor: '#ffed8f',
    borderRadius: '50%',
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-1.5rem',
    marginLeft: '-1rem',
    border: `3px solid ${listOfColors.disabledGold}` + '4a'
  },
  circleDisabledSilver: {
    backgroundColor: '#e3e3e3',
    borderRadius: '50%',
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-1.5rem',
    marginLeft: '-1rem',
    border: `3px solid ${listOfColors.disabledSilver}` + '4a'
  },
  circleDisabledBronze: {
    backgroundColor: '#e9c7a5',
    borderRadius: '50%',
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-1.5rem',
    marginLeft: '-1rem',
    border: `3px solid ${listOfColors.disabledBronze}` + '4a'
  }
}
interface CharenceService {
  id: number;
  isActive: boolean;
  level_Id: number;
  price_Service: string
  title: string
  type_Id: number
}
interface CharenceUser {
  id: number,
  userId: string,
  user_name: string,
  service_Id: number,
  is_Select: boolean,
  is_Used: boolean,
  date_Select: string,
  date_Used: object,
  requested_ID: object,
  service_name: string,
  level_ID: number,
  type_ID: number
}
const IconList = [
  <PriceChangeOutlined />,
  <CreditCard />,
  <VolunteerActivism />,
]

function CostumerAssignedServices() {
  const [ListOfCharence_Users, setListOfCharence_Users] = useState<Array<CharenceUser>>([]);
  const [isFetch, setIsFetch] = useState(false);
  // const [ListOfCharense_Services, setListOfCharense_Services] = useState<Array<CharenceService>>([]);
  const navigate = useNavigate();
  // _____________________________________________________________________________________________________________________________________
  useEffect(() => {
    handleGetListOfServices();
  }, []);

  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)"
  });

  const isTablet = useMediaQuery({
    query: "((min-width:650px) and (max-width: 900px))"
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 400px)"
  });


  const handleGetListOfServices = async () => {
    const { data, error }: getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/User/Find_list_service_User`) as getReq;
    if (!error) {
      setListOfCharence_Users(data.charence_Users);
      setIsFetch(true);
      // setListOfCharense_Services(data.charense_Services)
    }
  }
  const handleSelectService = async (serviceId) => {
    const { data, error }: postReq = await postRequest(`${process.env.REACT_APP_BASE_URL}/User/add_charencese_users?Service_ID=${serviceId}`) as postReq;
    if (!error) {
      toast.success('خدمت مورد نظر با موفقیت ایجاد شد!');
      navigate(0);
    }
  }
  if (ListOfCharence_Users.length === 0 && isFetch) {
    return (
      <div style={{ textAlign: 'center' }}>
        <img src={NoData} alt="" style={{ height: '80vh' }} />
      </div>
    )
  } else {
    return (
      <div className='background'>
        {
          ListOfCharence_Users?.length ?
            <div>
              <div style={{ width: '100%', textAlign: 'center', display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                <Alert severity="info" sx={{ width: 'fit-content', marginTop: "2rem" }}>
                  <AlertTitle sx={{ fontWeight: 'bold', fontSize: '2rem' }}>سرویس های انتخاب شده </AlertTitle>
                </Alert>
              </div>
              <Alert severity="success" sx={{ width: 'fit-content', }}>
                <AlertTitle sx={{ fontSize: '1rem' }}>سرویس های تایید شده </AlertTitle>
              </Alert>
              <Box sx={isDesktop ? style.gridBox : isTablet ? style.tabletGridBox : style.mobileGridBox}>
                {
                  ListOfCharence_Users
                    .filter((elemetn) => { return elemetn.is_Used == true }).map(service => {
                      return (
                        <CurrencyCard disableSelectBtn={true} isDesktop={isDesktop} alert="در انتظار بررسی" service={service} handleSelectService={handleSelectService} ListOfCharence_Users={ListOfCharence_Users} />
                      )
                    })}
              </Box>
              <Alert severity="warning" sx={{ width: 'fit-content', marginTop: "2rem" }}>
                <AlertTitle sx={{ fontSize: '1rem' }}>سرویس های در انتظار تایید  </AlertTitle>
              </Alert>
              <Box sx={isDesktop ? style.gridBox : isTablet ? style.tabletGridBox : style.mobileGridBox}>
                {
                  ListOfCharence_Users
                    .filter((elemetn) => { return elemetn.is_Used == false })
                    .map(service => {
                      return (
                        <CurrencyCard disableSelectBtn={true} isDesktop={isDesktop} alert="در انتظار بررسی" service={service} handleSelectService={handleSelectService} ListOfCharence_Users={ListOfCharence_Users} />
                      )
                    })}
              </Box>
            </div>
            : <div style={{ width: '100vw', height: 'calc( 100vh - 64px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Loading type="cylon" color="#000" />
            </div>
        }
      </div>
    )
  }
}

export default CostumerAssignedServices
